export function localSideName(gameType, color) {
  if (gameType === 'xiangqi') return color === 'w' ? 'Đỏ' : 'Đen';
  if (gameType === 'caro') return color === 'w' ? 'X' : 'O';
  return color === 'w' ? 'Trắng' : 'Đen';
}

export function createLocalResignResult({ mode, turn, gameType }) {
  const loser = mode === 'bot' ? 'w' : turn;
  const winner = loser === 'w' ? 'b' : 'w';
  return {
    kind: 'resign',
    winner,
    reason: mode === 'bot'
      ? `${localSideName(gameType, loser)} đầu hàng — Máy thắng`
      : `${localSideName(gameType, loser)} đầu hàng — ${localSideName(gameType, winner)} thắng`
  };
}

export function createLocalDrawResult({ mode }) {
  return {
    kind: 'draw',
    winner: null,
    reason: mode === 'bot'
      ? 'Hòa — kết thúc ván luyện tập'
      : 'Hòa theo thỏa thuận'
  };
}

export function isValidLocalResult(value) {
  if (!value || typeof value !== 'object') return false;
  if (!['resign', 'draw'].includes(value.kind)) return false;
  if (![null, 'w', 'b'].includes(value.winner)) return false;
  return typeof value.reason === 'string' && value.reason.length > 0 && value.reason.length <= 160;
}
